// extracted by mini-css-extract-plugin
export default {"notificationContent":"styles_notificationContent__ILW-S","notificationImage":"styles_notificationImage__Lwscj"};